import request from '@/utils/request'

export function fetchList(data) {
  return request({
    url: '/ProgramPrice/List',
    method: 'post',
    data,
  })
}

export function getItem(id) {
  return request({
    url: '/ProgramPrice/Get',
    method: 'post',
    data: { id },
  })
}

export function createItem(data) {
  console.log('createItem', data)

  return request({
    url: '/ProgramPrice/Create',
    method: 'post',
    data,
  })
}

export function updateItem(data) {
  console.log('updateItem', data)

  return request({
    url: '/ProgramPrice/Update',
    method: 'post',
    data,
  })
}

export function deleteItem(data) {
  return request({
    url: '/ProgramPrice/Delete',
    method: 'delete',
    data,
  })
}

export function fetchAll() {
  return request({
    url: '/ProgramPrice/List',
    method: 'post',
    data: {
      page: 0,
      limit: 0,
    },
  })
}
